"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorConstants = void 0;
/**
 * Color Constant hex codes
 *
 * @author osbornb
 */
class ColorConstants {
}
exports.ColorConstants = ColorConstants;
/**
 * Black hex color
 */
ColorConstants.BLACK = '#000000';
/**
 * Blue hex color
 */
ColorConstants.BLUE = '#0000FF';
/**
 * Brown hex color
 */
ColorConstants.BROWN = '#A52A2A';
/**
 * Cyan hex color
 */
ColorConstants.CYAN = '#00FFFF';
/**
 * Dark Gray hex color
 */
ColorConstants.DKGRAY = '#444444';
/**
 * Gray hex color
 */
ColorConstants.GRAY = '#888888';
/**
 * Green hex color
 */
ColorConstants.GREEN = '#00FF00';
/**
 * Light Gray hex color
 */
ColorConstants.LTGRAY = '#CCCCCC';
/**
 * Magenta hex color
 */
ColorConstants.MAGENTA = '#FF00FF';
/**
 * Orange hex color
 */
ColorConstants.ORANGE = '#FFA500';
/**
 * Pink hex color
 */
ColorConstants.PINK = '#FFC0CB';
/**
 * Purple hex color
 */
ColorConstants.PURPLE = '#800080';
/**
 * Red hex color
 */
ColorConstants.RED = '#FF0000';
/**
 * Violet hex color
 */
ColorConstants.VIOLET = '#EE82EE';
/**
 * White hex color
 */
ColorConstants.WHITE = '#FFFFFF';
/**
 * Yellow hex color
 */
ColorConstants.YELLOW = '#FFFF00';
//# sourceMappingURL=ColorConstants.js.map